
export const configReducer = (config) => (state = config, {type, payload}) => {
  return config;
}
